import SquaredBoxSvg344x95 from './SquaredBoxSvg344x95';

export default SquaredBoxSvg344x95;
export { SquaredBoxSvg344x95 };
